function beta() {
  // eslint-disable-next-line
  console.log('I am beta')
}

function charlie() {
  // eslint-disable-next-line
  console.log('I am charlie')
}

export {beta, charlie}